import { Text, Button, Link, Icon } from "@chakra-ui/react";
import { FaEnvelope } from "react-icons/fa";

const ContactMe = (): JSX.Element => {
  return (
    <Button as={Link} href={"mailto:manishparui@hotmail.com"} variant={"neon"}>
      <Icon as={FaEnvelope} />
      <Text marginLeft={3}>Contact Me</Text>
    </Button>
  );
};

export default ContactMe;
